import { axios, def, handleError } from './internal';

function AdminDashboard(setData) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_dashboard')
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, ...(res.data.data ?? {}) });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

export { AdminDashboard };
